export const addTerminalsSearchCriteria = (content) => {
  return (dispatch) => {
     dispatch({
        type: 'ADD_TERMINALS_SEARCH_CRITERIA',
        data: content
     })
  }
}

export const addPartsSearchCriteria = (content) => {
  return (dispatch) => {
     dispatch({
        type: 'ADD_PARTS_SEARCH_CRITERIA',
        data: content
     })
  }
}

export const addStationsSearchCriteria = (content) => {
  return (dispatch) => {
     dispatch({
        type: 'ADD_STATIONS_SEARCH_CRITERIA',
        data: content
     })
  }
}

export const addCompaniesSearchCriteria = (content) => {
  return (dispatch) => {
     dispatch({
        type: 'ADD_COMPANIES_SEARCH_CRITERIA',
        data: content
     })
  }
}

export const addUsersSearchCriteria = (content) => {
  return (dispatch) => {
     dispatch({
        type: 'ADD_USERS_SEARCH_CRITERIA',
        data: content
     })
  }
}


// WEBPACK FOOTER //
// ./src/actions/searchActions.js